module.exports = __webpack_public_path__ + "static/media/reliable.476578da.svg";